import { Button, Tooltip } from '@chain-zen/ui'

import type { IStopWarehouse } from '../../../../../../types/shipment'

export const WarehouseDisplay = ({ warehouse, onEdit }: { warehouse: IStopWarehouse | null; onEdit: () => void }) => {
  return (
    <div className="relative w-full p-1.5 border border-gray-200 dark:border-gray-600 rounded-md flex items-center gap-2 overflow-hidden">
      <div className="min-w-0 flex-1 overflow-hidden">
        <p className="font-medium text-sm truncate">{warehouse?.name || 'No warehouse selected'}</p>
        {!!warehouse?.address?.addressLabel && (
          <p className="text-xs text-muted-foreground mt-0.5 truncate max-w-[500px]">
            {warehouse.address.addressLabel}
          </p>
        )}
      </div>
      {!!warehouse?.locationID && (
        <Tooltip content="Edit warehouse location">
          <Button
            variant="outline"
            size="sm"
            onClick={onEdit}
            className="h-7 px-2 text-xs flex-shrink-0 whitespace-nowrap"
          >
            Edit
          </Button>
        </Tooltip>
      )}
    </div>
  )
}
